import React from 'react';
import styles from './index.module.scss';

import { InfoBanner, OverflowText } from 'components';

const LOCKED_REASON_CODES = {
  // Future codes can be added here
};

export default function LockedReason({ reason = '', code = '' }) {
  const msg = !reason ? null : (
    <>
      <strong>Locked Reason</strong>:{' '}
      <OverflowText
        text={LOCKED_REASON_CODES[code] || reason}
        trimLength={150}
        className={styles.text}
      />
    </>
  );

  return (
    <InfoBanner
      isInvalid
      gap="15"
      iconSize="24"
      className={styles.container}
      iconClassName={styles.icon}
      messageClassName={styles.message}
    >
      {msg}
    </InfoBanner>
  );
}
